import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { services } from '@config';
import FeatureIcon from '@components/icons/feature';

const StyledSection = styled.section`
  ${({ theme }) => theme.mixins.section};
  background: var(--paper-soft);
  border-top: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
`;

const StyledInner = styled.div`
  ${({ theme }) => theme.mixins.container};
`;

const StyledHead = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 52px;

  h2 {
    margin: 0;
    max-width: 640px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 36px;
  }
`;

const StyledAll = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
  color: var(--blue);
  font-weight: 600;

  &:hover,
  &:focus {
    gap: 12px;
  }
`;

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;

  @media (max-width: 980px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 620px) {
    grid-template-columns: 1fr;
  }
`;

const StyledCard = styled(Link)`
  ${({ theme }) => theme.mixins.card};
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 32px;
  color: var(--text-soft);

  &:hover,
  &:focus {
    color: var(--text-soft);
    transform: translateY(-6px);
    border-color: rgba(86, 112, 246, 0.45);
    box-shadow: var(--shadow-card);
  }

  .icon {
    ${({ theme }) => theme.mixins.flexCenter};
    width: 54px;
    height: 54px;
    border-radius: 16px;
    color: #ffffff;
    background: var(--gradient);
    box-shadow: 0 16px 34px -18px rgba(86, 112, 246, 0.9);
  }

  h3 {
    margin: 0;
    font-size: var(--fz-xxl);
  }

  p {
    margin: 0;
    color: var(--text-soft);
    font-size: var(--fz-sm);
    line-height: 1.6;
  }

  .more {
    margin-top: auto;
    padding-top: 6px;
    color: var(--blue);
    font-size: var(--fz-sm);
    font-weight: 600;
  }
`;

const Services = () => (
  <StyledSection id="services">
    <StyledInner>
      <StyledHead>
        <div>
          <p className="eyebrow">Услуги</p>
          <h2>Разработка и управление IT-проектами</h2>
        </div>
        <StyledAll to="/services">Все услуги →</StyledAll>
      </StyledHead>

      <StyledGrid>
        {services.map(service => (
          <StyledCard key={service.icon} to={`/services#${service.icon}`}>
            <span className="icon">
              <FeatureIcon name={service.icon} size={26} />
            </span>
            <h3>{service.title}</h3>
            <p>{service.tagline}</p>
            <span className="more">Подробнее →</span>
          </StyledCard>
        ))}
      </StyledGrid>
    </StyledInner>
  </StyledSection>
);

export default Services;
